<template>
  <div>
    <seller-select-modal v-if="editable" class="component-margin" @selected="selectedSeller($event)"/>
    <div v-if="(editable && memberId !== '') || !editable">
      <b-row class="component-margin">
        <b-col sm="3">
            <b-input size="sm" v-model="nameFilter" placeholder="ASINコード、JANコード、商品名、FBA番号"/>
        </b-col>
        <!-- <b-col sm="1">
          <b-checkbox size="sm" v-model="showFlag">分析表示</b-checkbox>
        </b-col> -->
        <b-col sm="5">
          <b-btn size="sm" @click="outputCsvInfo()" variant="danger">ファイル出力(全件)</b-btn>
          <b-btn size="sm" @click="outputCsv()" class="component-margin-left" variant="success">ファイル出力(画面表示分)</b-btn>
          <b-btn v-if="editable" size="sm" class="component-margin-left" @click="createKako(null)" variant="danger">新規登録</b-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                  :items="filteredItems" :fields="fields"
                  :current-page="currentPage" :per-page="perPage"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
            <template slot="purchaseDate" slot-scope="row">
              <label>{{formatDate(row.value)}}</label>
            </template>
            <template slot="condition" slot-scope="row">
              <label>{{productConditionText(row.value)}}</label>
            </template>
            <template slot="totalAmount" slot-scope="row">
              <label>{{formatPrice(row.value)}}</label>
            </template>

            <template slot="weight" slot-scope="row">
              <weight-type :type="row.item['weightType']"/>
              <div><label>{{row.item['weight']}}</label></div>
            </template>
            <template slot="inboundDate" slot-scope="row">
              <label>{{formatDate(row.value)}}</label>
            </template>
            <template slot="shippingDate" slot-scope="row">
              <label>{{formatDate(row.value)}}</label>
            </template>
            <template slot="forcastShippingCost" slot-scope="row">
              <label>{{formatPrice(row.value)}}</label>
            </template>
            <template slot="forcastTargetSales" slot-scope="row">
              <label>{{formatPrice(row.value)}}</label>
            </template>
            <template slot="forcastTargetProfit" slot-scope="row">
              <label>{{formatPrice(row.value)}}</label>
            </template>
            <template slot="actualShippingCost" slot-scope="row">
              <label>{{formatPrice(row.value)}}</label>
            </template>
            <template slot="fixedSales" slot-scope="row">
              <label>{{formatPrice(row.value)}}</label>
            </template>
            <template slot="refund" slot-scope="row">
              <label>{{formatPrice(row.value)}}</label>
            </template>
            <template slot="fixedSales2" slot-scope="row">
              <label>{{formatPrice(row.value)}}</label>
            </template>
            <template slot="refund2" slot-scope="row">
              <label>{{formatPrice(row.value)}}</label>
            </template>
            <template slot="fixedSales3" slot-scope="row">
              <label>{{formatPrice(row.value)}}</label>
            </template>
            <template slot="lastSales" slot-scope="row">
              <label>{{formatPrice(row.value)}}</label>
            </template>
            <template slot="lastProfit" slot-scope="row">
              <label>{{formatPrice(row.value)}}</label>
            </template>
            <template slot="restStock" slot-scope="row">
              <label>{{formatPrice(row.value)}}</label>
            </template>
            <!-- <template slot="operation" slot-scope="row">
              <b-button size="sm" @click="editModal(row)" variant="warning">操作</b-button>
            </template> -->
            <template slot="operation" slot-scope="row">
              <b-button  size="sm" :id="`popover-`+ row.index" variant="primary">操作</b-button>
              <b-popover
                :target="`popover-`+ row.index"
                :placement="placement"
                title="操作バー"
                triggers="click blur"
                :content="`popover-1-`+ row.index">
                <b-row class="component-margin-half">
                  <b-col md="12">
                    <b-button @click="editModal(row)" size="md" variant="danger">　　修正　　</b-button>
                  </b-col>
                </b-row>
                <b-row class="component-margin-half">
                  <b-col md="12">
                    <b-button @click="reverseInboundHistoryModal(row)" size="md" variant="danger">　入庫戻し　</b-button>
                  </b-col>
                </b-row>
              </b-popover>
            </template>
          </b-table>
          <div md="6" v-if="(editable && memberId !== '') || !editable">
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"/>
          </div>
        </b-col>
      </b-row>
    </div>
    <inbound-history-modal ref="historyModal"/>
    <b-modal ref="editModal" title="分析用データ修正" @ok="handleOk">
      <b-form-group size="sm" horizontal label="見込み送料" label-class="text-sm-right" label-for="date">
        <b-form-input size="sm" id="forcastShippingCost" v-model="editItem.forcastShippingCost" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="T売上" label-class="text-sm-right" label-for="date">
        <b-form-input size="sm" id="forcastTargetSales" v-model="editItem.forcastTargetSales" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="T利益" label-class="text-sm-right" label-for="date">
        <b-form-input size="sm" id="forcastTargetProfit" v-model="editItem.forcastTargetProfit" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="販売数" label-class="text-sm-right" label-for="date">
        <b-form-input size="sm" id="salesQuantity" v-model="editItem.salesQuantity" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="確定売上" label-class="text-sm-right" label-for="date">
        <b-form-input size="sm" id="fixedSales" v-model="editItem.fixedSales" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="返金" label-class="text-sm-right" label-for="date">
        <b-form-input size="sm" id="refund" v-model="editItem.refund" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="確定売上2" label-class="text-sm-right" label-for="date">
        <b-form-input size="sm" id="fixedSales2" v-model="editItem.fixedSales2" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="返金2" label-class="text-sm-right" label-for="date">
        <b-form-input size="sm" id="refund2" v-model="editItem.refund2" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="確定売上3" label-class="text-sm-right" label-for="date">
        <b-form-input size="sm" id="fixedSales3" v-model="editItem.fixedSales3" type="text"/>
      </b-form-group>
      <b-form-group v-if="editable" size="sm" horizontal label="データ参照" label-class="text-sm-right" label-for="onlyPrintLabel">
       <b-button @click="historyRow()" size="md" variant="danger">関連データ参照</b-button>
      </b-form-group>
    </b-modal>
    
    <b-modal ref="createModal" title="分析用データ登録" @ok="handleCreateOk">
      <b-form-group size="sm" horizontal label="FBA番号" label-class="text-sm-right" label-for="date">
        <b-form-input size="sm" id="fbaNumberInModal" v-model="editItem.fbaNumberInModal" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="セット有無" label-class="text-sm-right" label-for="setInModal">
        <b-select size="sm" id="setInModal" v-model="editItem.setInModal" :options="setTypes"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="ASIN" label-class="text-sm-right" label-for="asinInModal">
        <b-form-input size="sm" id="asinInModal" v-model="editItem.asinInModal" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="状態" label-class="text-sm-right" label-for="conditionInModal">
        <b-select size="sm" id="conditionInModal" v-model="editItem.conditionInModal" :options="conditionTypes"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="SKU" label-class="text-sm-right" label-for="skuInModal">
        <b-form-input size="sm" id="skuInModal" v-model="editItem.skuInModal" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="商品コード" label-class="text-sm-right" label-for="jancodeInModal">
        <b-form-input size="sm" id="jancodeInModal" v-model="editItem.jancodeInModal" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="発送数" label-class="text-sm-right" label-for="shippingQuantityInModal">
        <b-form-input size="sm" id="shippingQuantityInModal" v-model="editItem.shippingQuantityInModal" type="text"/>
      </b-form-group>

      <b-form-group size="sm" horizontal label="購入日" label-class="text-sm-right" label-for="purchaseDateInModal">
        <date-picker id="purchaseDateInModal" class="table-linput zoom-back-3" :addclearbtn=true :dispMonth=false :notinitdate=true :value="editItem.purchaseDateInModal" @change="($event) => editItem.purchaseDateInModal = $event"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="入庫日" label-class="text-sm-right" label-for="inboundDateInModal">
        <date-picker id="inboundDateInModal" class="table-linput zoom-back-2" :addclearbtn=true :dispMonth=false :notinitdate=true :value="editItem.inboundDateInModal" @change="($event) => editItem.inboundDateInModal = $event"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="発送日" label-class="text-sm-right" label-for="shippingDateInModal">
        <date-picker id="shippingDateInModal" class="table-linput zoom-back-1" :addclearbtn=true :dispMonth=false :notinitdate=true :value="editItem.shippingDateInModal" @change="($event) => editItem.shippingDateInModal = $event"/>
      </b-form-group>

      <b-form-group size="sm" horizontal label="購入単価" label-class="text-sm-right" label-for="purchaseUnitPriceInModal">
        <b-form-input size="sm" id="purchaseUnitPriceInModal" v-model="editItem.purchaseUnitPriceInModal" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="購入店" label-class="text-sm-right" label-for="shopInModal">
        <b-form-input size="sm" id="shopInModal" v-model="editItem.shopInModal" type="text"/>
      </b-form-group>

      <b-form-group size="sm" horizontal label="商品名" label-class="text-sm-right" label-for="productNameInModal">
        <b-form-input size="sm" id="productNameInModal" v-model="editItem.productNameInModal" type="text"/>
      </b-form-group>
    </b-modal>
    <b-modal ref="messagePopup" ok-only hide-header>
      <div class="text-center">{{confirmMessage}}</div>
    </b-modal>
    <b-modal ref="reverseInboundHistoryPopup" title="入庫処理戻し" @ok="reverseInboundHistoryOk" no-close-on-backdrop=true no-close-on-esc=true content-class="shadow">
      <b-form-group size="sm" horizontal label="戻し数量" label-class="text-sm-right" label-for="reverseQuantity">
        <b-form-input size="sm" id="reverseQuantity" v-model="reverseQuantity" type="text"/>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import SellerSelectModal from '@/components/common/SellerSelectModal';
import ConditionType from '@/types/ConditionType';
import DatePicker from '@/components/common/DatePicker';
import InboundHistoryModal from '@/components/inbound/InboundHistoryModal';
import SetType from '@/types/SetType';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    editable: {
      default: false,
    }
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'purchaseDate',label: '購入日', sortable: true, variant: 'base' },
        { key: 'condition',label: '状態', sortable: true, variant: 'base' },
        { key: 'asin',label: 'ASIN', sortable: true, variant: 'base' },
        { key: 'janCode',label: 'JANコード', sortable: true, variant: 'base' },
        { key: 'productNameEn',label: '商品名(英語)', sortable: true, variant: 'base' },
        { key: 'shippingQuantity',label: '発送数', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'totalAmount',label: '総額', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'shopName',label: '購入店', sortable: true, variant: 'base' },
        { key: 'weight',label: '重量(kg)', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'inboundDate',label: '入庫日', sortable: true, variant: 'base' },
        { key: 'shippingDate',label: '発送日', sortable: true, variant: 'base' },
        { key: 'fbaNumber',label: 'FBA番号', sortable: true, variant: 'base' },
        { key: 'forcastShippingCost',label: '見込み送料', sortable: true, variant: 'base', class: 'table-right test' },
        { key: 'forcastTargetSales',label: 'T売上', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'forcastTargetProfit',label: 'T利益', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'shippingFactor',label: '送料係数', sortable: true, variant: 'success', class: 'table-right' },
        { key: 'actualShippingCost',label: '按分送料', sortable: true, variant: 'success', class: 'table-right' },
        { key: 'salesQuantity',label: '販売数', sortable: true, variant: 'warning', class: 'table-right' },
        { key: 'restQuantity',label: '残数量', sortable: true, variant: 'success', class: 'table-right' },
        { key: 'fixedSales',label: '確定売上', sortable: true, variant: 'warning', class: 'table-right' },
        { key: 'refund',label: '返金', sortable: true, variant: 'warning', class: 'table-right' },
        { key: 'fixedSales2',label: '確定売上2', sortable: true, variant: 'warning', class: 'table-right' },
        { key: 'refund2',label: '返金2', sortable: true, variant: 'warning', class: 'table-right' },
        { key: 'fixedSales3',label: '確定売上3', sortable: true, variant: 'warning', class: 'table-right' },
        { key: 'lastSales',label: '最終売上', sortable: true, variant: 'success', class: 'table-right' },
        { key: 'lastProfit',label: '最終利益', sortable: true, variant: 'success', class: 'table-right' },
        { key: 'forcastTagetSalesRate',label: 'T売上達成率', sortable: true, variant: 'success', class: 'table-right' },
        { key: 'forcastTargetProfitRate',label: 'T利益達成率', sortable: true, variant: 'success', class: 'table-right' },
        { key: 'restStock',label: '残在庫', sortable: true, variant: 'success', class: 'table-right' },
        { key: 'operation', label: '操作', sortable: false, variant: 'success', class: 'table-cw4' }
      ],
      currentPage: 1,
      perPage: 25,
      totalRows: 0,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: '',
      nameFilter: '',
      editItem: {},
      filteredItem: {},
      confirmMessage: '',
      memberId: '',
      showFlag: false,
      fbaNumberInModal: '',
      setInModal: '',
      asinInModal: '',
      conditionInModal: '',
      skuInModal: '',
      jancodeInModal: '',
      shippingQuantityInModal: '',
      purchaseDateInModal: '',
      inboundDateInModal: '',
      reverseQuantity: 0,
      shippingDateInModal: '',
      purchaseUnitPriceInModal: '',
      shopInModal: '',
      productNameInModal: '',
      conditionTypes: ConditionType.values(),
      setTypes: SetType.values()
    };
  },
  created() {
    if (this.editable === false) {
      var searchWord = this.$route.query.searchword;
      if(searchWord != null){
        this.nameFilter = searchWord;
      }
      this.memberId = this.$store.state.account;
      api.getAnalysisHistory(this.memberId, (items) => {
        this.items = items;
        this.totalRows = this.items.length;
      });
    }
  },
  computed: {
    filteredItems() {
      this.filteredItem = {};
      var aaaList = ['','','','',''];
      if(this.nameFilter !== ''){
        var bbbList = this.nameFilter.split(',');
        for(let i = 0; i<bbbList.length; i++){
          if(i > 4){
            continue;
          }
          aaaList[i] = bbbList[i];
        }
      }
      this.filteredItem = this.items.filter(item => {
        return (this.nameFilter === '' || (item.asin !== null && item.asin.indexOf(aaaList[0]) !== -1) ||
                  (item.janCode !== null && item.janCode.indexOf(aaaList[0]) !== -1) ||
                  (item.productNameEn !== null && item.productNameEn.indexOf(aaaList[0]) !== -1) ||
                  (item.fbaNumber !== null && item.fbaNumber.indexOf(aaaList[0]) !== -1))
                  ||
                  (aaaList[1] !== '' && ((item.asin !== null && item.asin.indexOf(aaaList[1]) !== -1) ||
                  (item.janCode !== null && item.janCode.indexOf(aaaList[1]) !== -1) ||
                  (item.productNameEn !== null && item.productNameEn.indexOf(aaaList[1]) !== -1) ||
                  (item.fbaNumber !== null && item.fbaNumber.indexOf(aaaList[1]) !== -1)))
                  ||
                  (aaaList[2] !== '' && ((item.asin !== null && item.asin.indexOf(aaaList[2]) !== -1) ||
                  (item.janCode !== null && item.janCode.indexOf(aaaList[2]) !== -1) ||
                  (item.productNameEn !== null && item.productNameEn.indexOf(aaaList[2]) !== -1) ||
                  (item.fbaNumber !== null && item.fbaNumber.indexOf(aaaList[2]) !== -1)))
                  ||
                  (aaaList[3] !== '' && ((item.asin !== null && item.asin.indexOf(aaaList[3]) !== -1) ||
                  (item.janCode !== null && item.janCode.indexOf(aaaList[3]) !== -1) ||
                  (item.productNameEn !== null && item.productNameEn.indexOf(aaaList[3]) !== -1) ||
                  (item.fbaNumber !== null && item.fbaNumber.indexOf(aaaList[3]) !== -1)))
                  ||
                  (aaaList[4] !== '' && ((item.asin !== null && item.asin.indexOf(aaaList[4]) !== -1) ||
                  (item.janCode !== null && item.janCode.indexOf(aaaList[4]) !== -1) ||
                  (item.productNameEn !== null && item.productNameEn.indexOf(aaaList[4]) !== -1) ||
                  (item.fbaNumber !== null && item.fbaNumber.indexOf(aaaList[4]) !== -1)));
        });
      this.totalRows = this.filteredItem.length;
      this.currentPage = 1;
      return this.filteredItem;
    },
  },
  methods: {
    selectedSeller($event) {
      this.memberId = $event.amazonAccount;
      api.getAnalysisHistory(this.memberId, (items) => {
        this.items = items;
        this.totalRows = this.items.length;
      });
    },
    historyRow(){
      this.$refs.historyModal.showModal(this.editItem);
    },
    editModal(row) {
      this.editItem = {};
      this.isUpdate = false;
      if (row !== null) {
        this.isUpdate = true;
        // Object.assign(this.editItem , row.item);
        this.editItem =  Object.assign({}, this.editItem , row.item);
      }
      this.$refs.editModal.show();
    },
    reverseInboundHistoryModal(row){
      this.editItem = {};
      this.isUpdate = false;
      if (row !== null) {
        // Object.assign(this.editItem , row.item);
        this.editItem =  Object.assign({}, this.editItem , row.item);
      }
      this.$refs.reverseInboundHistoryPopup.show();
    },
    createKako(){
      this.editItem = {};
      this.$refs.createModal.show();
    },
    handleOk() {
      if (this.isUpdate) {
        api.updateAnalysisHistory(this.memberId, this.editItem, (items) => {
          this.items = items;
          // this.totalRows = this.items.length;
          this.confirmMessage = '登録内容を変更しました。';
          this.$refs.messagePopup.show();
        });
      }
    },
    handleCreateOk() {
      api.createAnalysisHistory(this.memberId, this.editItem, (items) => {
        this.items = items;
        // this.totalRows = this.items.length;
        this.confirmMessage = '登録内容を変更しました。';
        this.$refs.messagePopup.show();
      });
    },
    reverseInboundHistoryOk(){
      api.reverseInboundHistory(this.memberId, this.reverseQuantity, this.editItem, (items) => {
        this.items = items;
        // this.totalRows = this.items.length;
        this.confirmMessage = '指定数量を入庫画面に戻しました。';
        this.$refs.messagePopup.show();
      });
    },
    outputCsv() {
      let csv = '\ufeff' + '購入日,状態,ASIN,JANコード,商品名(英語),発送数,総額,購入店,重量(kg),入庫日,発送日,FBA番号,見込み送料,T売上,T利益,送料係数,実際送料,販売数,残数量,確定売上,返金,確定売上2,返金2,確定売上3,最終売上,最終利益,T売上達成率,T利益達成率,残在庫\n';
      let ids = [ 'purchaseDate', 'condition', 'asin', 'janCode', 'productNameEn', 'shippingQuantity', 'totalAmount', 'shopName', 'weight', 'inboundDate', 'shippingDate', 'fbaNumber', 'forcastShippingCost', 'forcastTargetSales', 'forcastTargetProfit', 'shippingFactor', 'actualShippingCost', 'salesQuantity', 'restQuantity', 'fixedSales', 'refund', 'fixedSales2', 'refund2', 'fixedSales3', 'lastSales', 'lastProfit', 'forcastTagetSalesRate', 'forcastTargetProfitRate', 'restStock' ];
      let fileName = '';
      for (const item of this.filteredItem) {
        csv = csv + '"';
        for (const id of ids) {
          if(item[id] == null || item[id] === ''){
            csv += '","';
          } else{
            if(isNaN(item[id])){
              csv += item[id].replace(/"/g, '') + '","';
            } else{
              csv += item[id] + '","';
            }
            // csv += item[id] + '","';
          }
        }
        csv = csv.substring(0, csv.length - 2);
        csv += '\n';
      }
      fileName = 'shippingHistory_Result_only_display.csv';
      const blob = new Blob([csv], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    outputCsvInfo() {
      api.getAnalysisHistoryCsvData(this.memberId, (data) => {
        let csvInfos = data.csvData;
        let csv = '\uFEFF'; // BOMを追加
        for (const item of csvInfos) {
          csv += item + '\n';
        }
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'shippingHistory_Result.csv';
        link.click();
      });      
    },
    productConditionText(row) {
      if (row ==='0') {  return 'NEW'; }
      if (row ==='1') {  return 'USED'; }
    },
  },
};

Vue.component('seller-select-modal', SellerSelectModal);
Vue.component('date-picker', DatePicker);
Vue.component('inbound-history-modal', InboundHistoryModal);
</script>

<style>
.component-margin {
  margin-bottom: 1rem;
}

.zoom-back-0{
  z-index: 0;
}
.zoom-back-1{
  z-index: 1;
}
.zoom-back-2{
  z-index: 2;
}
.zoom-back-2{
  z-index: 3;
}
.component-margin-left {
  margin-left: 1rem;
}

@media (min-width: 768px) {
  .table-right  { text-align:right!important; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center!important; }
  .table-cw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:center!important; }
  .table-lw15 { max-width: 15rem; word-wrap: break-word;          text-align:left!important;   }
  .table-lw6  { max-width: 6rem; }
}
</style>
